import React, { useEffect } from "react";
import { Table, CardBody, Col, CardHeader, Row, Card } from "reactstrap";
import { api } from "../../../config";
import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";
import moment from "moment";
const PrintDoc = ({ innerRef, item, type }) => {
  const handleValidDate = (date) => {
    return moment.utc(date).local().format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  function getType(type) {
    let transType;
    switch (type) {
      case "CASH IN":
        transType = { label: "PENERIMAAN CASH", value: "CASH IN" };
        break;
      case "CASH OUT":
        transType = { label: "PENGELUARAN CASH", value: "CASH OUT" };
        break;
      case "CASH TRANSFER":
        transType = { label: "TRANSFER CASH", value: "CASH TRANSFER" };
        break;
      case "SALES":
        transType = { label: "PENJUALAN", value: "SALES" };
        break;
      case "PURCHASE":
        transType = { label: "PEMBELIAN", value: "PURCHASE" };
        break;
      case "EXPENSE":
        transType = { label: "BIAYA", value: "EXPENSE" };
        break;
      case "REVENUE":
        transType = { label: "PENDAPATAN", value: "REVENUE" };
        break;
      case "RECEIVABLE":
        transType = { label: "PIUTANG", value: "RECEIVABLE" };
        break;
      case "PAYABLE":
        transType = { label: "HUTANG", value: "PAYABLE" };
        break;
      default:
        transType = { label: "OTHER", value: "OTHER" };
        break;
    }
    return transType;
  }

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 10px 40px 10px" }}>
        <CardHeader className="border-bottom-dashed p-4 pb-3 pt-3">
          <div className="d-flex">
            <div className="flex-grow-1">
              <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="80" />
              <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="80" />
              <div className="mt-sm-3 mt-3">
                <h4 className="text-uppercase fw-semibold mb-1">{item.at_client && item.at_client.name}</h4>
                <h5 className=" mb-4 text-uppercase fw-semibold">TRANSAKSI {getType(item.type).label}</h5>
                <div className=" mb-2 text-uppercase fw-semibold">PROYEK {item.at_branch && item.at_branch.name}</div>
                <div className=" mb-1 text-uppercase hstack">
                  <div style={{ width: "130px" }}>Department</div>
                  <div style={{ width: "20px" }}>:</div>
                  <div>{item.at_department ? item.at_department.name : "-"}</div>
                </div>
                <div className=" mb-1 text-uppercase hstack">
                  <div style={{ width: "130px" }}>RAB / ANGGARAN</div>
                  <div style={{ width: "20px" }}>:</div>
                  <div>{item?.at_cvl?.name} - {item?.at_cvl_account?.name} / {item?.at_budget?.name ? item?.at_budget?.name : "-"}</div>
                </div>
                <div className=" mb-1 text-uppercase d-none">Metode Bayar: {item.at_pm ? item.at_pm.name : "-"}</div>
                <div className=" mb-1 text-uppercase hstack">
                  <div style={{ width: "130px" }}>TAG</div><div style={{ width: "20px" }}>:</div>
                  <div>{item.at_tag ? item.at_tag.name : "-"}</div>
                </div>
              </div>
            </div>
          </div>
        </CardHeader>
        <CardBody className="p-4 pb-3 pt-3">
          <Row className="g-3">
            <Col lg={6} xs={6}>
              <p className="text-muted mb-2 text-uppercase fw-semibold">No Transaksi</p>
              <h5 className="fs-14 mb-0">
                #<span id="invoice-no">{item.transaction_no}</span>
              </h5>
            </Col>
            <Col lg={6} xs={6}>
              <p className="text-muted mb-2 text-uppercase fw-semibold">Date / Due Date</p>
              <h5 className="fs-14 mb-0">
                <span id="invoice-date">
                  {handleValidDate(item.transactionat)} / {handleValidDate(item.dueat)}
                </span>
              </h5>
            </Col>
            <Col lg={12} xs={12}>
              <p className="text-muted mb-2 text-uppercase fw-semibold">Jumlah</p>
              <h5 className="fs-3 mb-0 fw-semibold">
                <span id="total-amount" className="text-success">
                  {currencyFormat(item.amount)}
                </span>
              </h5>
            </Col>
            <Col lg={12} xs={12}>
              <p className="text-muted mb-2 text-uppercase fw-semibold">Terbilang</p>
              <h5 className="fs-15 mb-0">
                <span id="total-amount">{numberToWords(item.amount)}</span>
              </h5>
            </Col>
          </Row>
        </CardBody>
        {(item.at_rls || []).length ? (
          <CardBody className="p-4 pb-3 pt-3 border-top border-top-dashed position-relative">
            <div>
              <h5>Detail Pengajuan Dana</h5>
              <Table className="invoice-table table-borderless table-nowrap mb-0">
                <thead className="align-middle">
                  <tr className="table-active">
                    <th scope="col" style={{ width: "20px" }}>
                      #
                    </th>
                    <th scope="col">Supplier</th>
                    <th scope="col">Type</th>
                    <th scope="col">No Transaksi</th>
                    <th scope="col">No Invoice</th>
                    <th scope="col">Jumlah Bayar</th>
                  </tr>
                </thead>
                <tbody id="newlink">
                  {(item.at_rls || [])
                    .sort((a, b) => a.id - b.id)
                    .map((o, i) => {
                      return (
                        <tr key={i} id={i} className="product">
                          <th scope="row" className="product-id">
                            {i + 1}
                          </th>
                          <td className="text-start">{o?.at_rls_vendor?.name}</td>
                          <td>{o?.type}</td>
                          <td>{o?.type === "SPK" ? o?.at_rls_contract?.transaction_no : o?.at_rls_purchase?.transaction_no}</td>
                          <td>{o?.type === "SPK" ? "-" : o?.at_rls_purchase?.transaction_reff}</td>
                          <td>{currencyFormat(o?.amount)}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </div>
          </CardBody>
        ) : null}
        {item.at_purchase && item.at_purchase.purchase_detail && (
          <CardBody className="p-4 pb-3 pt-2">
            <Table className="table-borderless text-center table-nowrap align-middle">
              <thead>
                <tr className="table-active">
                  <th scope="col" style={{ width: "30px" }}>
                    #
                  </th>
                  <th scope="col" className="text-start">
                    Detail Produk
                  </th>
                  <th scope="col" className="text-start">
                    Anggaran
                  </th>
                  <th scope="col">Harga</th>
                  <th scope="col">Jumlah</th>
                  <th scope="col">Penerimaan Barang</th>
                  <th scope="col" className="text-end">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody id="products-list">
                {(item.at_purchase.purchase_detail || []).map((o, i) => {
                  return (
                    <tr key={i} id={i} className="product">
                      <th scope="row" className="product-id">
                        {i + 1}
                      </th>
                      <td className="text-start">{o.name}</td>
                      <td className="text-start">{o.cvl_account}</td>
                      <td>Rp{currencyFormat(o.amount)}</td>
                      <td>{currencyFormat(o.quantity)}</td>
                      <td>{currencyFormat(o.accepted)}</td>
                      <td className="text-end">Rp{currencyFormat(o.amount * o.quantity)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </CardBody>
        )}
        <CardBody className="p-4 pb-3 pt-2">
          <div className="mt-0 mb-4">
            <div className="alert alert-item bg-soft-info">
              <p className="mb-0">
                <span className="fw-semibold fs-14">NOTES:</span>
                <span id="note" className="fs-13">
                  {" "}
                  {item.description}
                </span>
              </p>
            </div>
          </div>
          <Row className="g-3">
            <Col lg={4} xs={4}>
              <p className="mb-0 text-center">Bogor, {handleValidDate(item.createdat, "DD/MM/YYYY")}</p>
              <p className="mb-0 text-center">Pengajuan</p>
              <p className="mb-5 pb-3 fw-semibold text-center">{item.at_createdby ? item.at_createdby.name : ""}</p>
              <p style={{ height: "10px" }}></p>
              <p className="mt-5 text-center">................................</p>
            </Col>
            <Col lg={4} xs={4}>
              <p className="mb-0 text-center">Bogor, {item.approvedat && item.approvedat ? handleValidDate(item.approvedat) : "................................"}</p>
              <p className="mb-0 text-center">Disetujui Oleh</p>
              <p className="mb-5 pb-3 fw-semibold text-center">{item.at_approvedby ? item.at_approvedby.name : <span>&nbsp;</span>}</p>
              <p style={{ height: "10px" }}></p>
              <p className="mt-5 text-center">................................</p>
            </Col>
            <Col lg={4} xs={4}>
              <p className="mb-0 text-center">Bogor, ....................</p>
              <p className="mb-0 text-center">Penerima</p>
              <p className="mb-5 pb-3 fw-semibold text-center">{item.at_user ? item.at_user.name : <span>&nbsp;</span>}</p>
              <p style={{ height: "10px" }}></p>
              <p className="mt-5 text-center">................................</p>
            </Col>
          </Row>
        </CardBody>
        <CardBody className="p-4 pb-3 pt-3">
          <Row className="g-3">
            {(item.at_file || []).map((f, i) => {
              if (f.isDeleted) {
                return null;
              } else {
                return (
                  <Col lg={6} xs={6} key={i}>
                    <img src={f.filename === "" ? "" : `${api.MEDIA_URL}/media/${f.filename}`} alt="" data-dz-thumbnail="" className="img-fluid rounded bg-light" />
                  </Col>
                );
              }
            })}
          </Row>
        </CardBody>
      </div>
    </div>
  );
};

export default PrintDoc;
